export const fourGFormAreas = `
		"cellId name"
		"earfcn frequency"
		"band antennaModel"
		"height azimuth"
		"mechanicalTilt electricalTilt"
		"totalTilt zone"
		"tac pci"
		"submitButtons submitButtons"
		`;

export const fiveGFormAreas = `
		"cellId name"
		"nrarfcn frequency"
		"band antennaModel"
		"height azimuth"
		"mechanicalTilt electricalTilt"
		"mechanicalTiltBracket mechanicalTiltBracketMount"
		"spinningRange ."
		"submitButtons submitButtons"
		`;

export const mechanicalTiltBracketOptions = [
	{
		label: 'Yes',
		value: true,
	},
	{
		label: 'No',
		value: false,
	},
];

export const formFields = {
	cellId: {
		label: 'Cell ID',
		name: 'cellId',
		placeholder: 'Enter cell ID',
	},
	name: {
		label: 'Cell Name',
		name: 'name',
		placeholder: 'Enter cell name',
	},
	frequency: {
		label: 'Frequency',
		name: 'frequency',
		placeholder: 'Enter frequency',
	},
	band: {
		label: 'Band',
		name: 'band',
		placeholder: 'Select band',
	},
	antennaModel: {
		label: 'Antenna Model',
		name: 'antennaModel',
		placeholder: 'Choose or enter model',
	},
	height: {
		label: 'Height',
		name: 'height',
		placeholder: 'Enter height',
	},
	azimuth: {
		label: 'Azimuth',
		name: 'azimuth',
		placeholder: 'Enter azimuth',
	},
	mechanicalTilt: {
		label: 'Mechanical Tilt',
		name: 'mechanicalTilt',
		placeholder: 'Enter mechanical tilt',
	},
	electricalTilt: {
		label: 'Electrical Tilt',
		name: 'electricalTilt',
		placeholder: 'Enter electrical tilt',
	},
	mechanicalTiltBracket: {
		label: 'Mechanical Tilt Bracket',
		name: 'mechanicalTiltBracket',
		placeholder: 'Enter mechanical tilt bracket',
	},
	mechanicalTiltBracketMount: {
		label: 'Mechanical Tilt Bracket Mount',
		name: 'mechanicalTiltBracketMount',
		placeholder: 'Enter bracket mount',
	},
	spinningRange: {
		label: 'Spinning Range',
		name: 'spinningRange',
		placeholder: 'Enter spinning range',
	},
	nrarfcn: {
		label: 'NRARFCN',
		name: 'nrarfcn',
		placeholder: 'Enter NRARFCN',
	},
	totalTilt: {
		label: 'Total Tilt',
		name: 'totalTilt',
		placeholder: 'Enter total tilt',
	},
	zone: {
		label: 'Zone',
		name: 'zone',
		placeholder: 'Choose or enter zone',
	},
	tac: {
		label: 'TAC',
		name: 'tac',
		placeholder: 'Enter TAC',
	},
	earfcn: {
		label: 'EARFCN',
		name: 'earfcn',
		placeholder: 'Enter EARFCN',
	},
	pci: {
		label: 'PCI',
		name: 'pci',
		placeholder: 'Enter PCI',
	},
};

